import Plyr from 'plyr';

function tryToSubmitEvent(eventName, eventParams) {
  try {
    // eslint-disable-next-line no-undef
    gtag('event', eventName, eventParams);
  } catch (e) {
    // Google Analytics unavailable — cookie compliance or ad blocker.
  }
}

if (document.querySelector('.section-audio') != null) {
  const player = new Plyr('#player', {
    controls: ['play', 'current-time', 'duration', 'progress'],
    invertTime: false,
  });

  const audioElem = document.querySelector('.section-audio .playaudio-container');
  const stickyaudio = audioElem.getBoundingClientRect();
  const fixedClass = 'audio--fixed';
  const hideAudio = document.getElementById('hide-audio');
  const AudioOffsetTop = stickyaudio.top + window.scrollY;

  hideAudio.onclick = () => {
    audioElem.style.visibility = 'hidden';
    audioElem.style.opacity = '0';
    player.pause();
  };

  window.addEventListener('scroll', () => {
    if (window.pageYOffset >= AudioOffsetTop + stickyaudio.height) {
      audioElem.classList.add(fixedClass);
    } else {
      audioElem.classList.remove(fixedClass);
      audioElem.style.visibility = 'visible';
      audioElem.style.opacity = '1';
    }
  });

  player.on('play', (event) => {
    const instance = event.detail.plyr;
    const progress = ((instance.currentTime / instance.duration) * 100).toFixed(0);

    tryToSubmitEvent('audio_play', {
      source: instance.source,
      current_time: instance.currentTime.toFixed(0),
      progress,
    });
  });

  player.on('pause', (event) => {
    const instance = event.detail.plyr;
    const progress = ((instance.currentTime / instance.duration) * 100).toFixed(0);

    if (!instance.ended) {
      tryToSubmitEvent('audio_paused', {
        source: instance.source,
        current_time: instance.currentTime.toFixed(0),
        progress,
      });
    }
  });

  player.on('ended', (event) => {
    const instance = event.detail.plyr;

    tryToSubmitEvent('audio_ended', {
      source: instance.source,
    });
  });
}
